module.exports = __webpack_public_path__ + "img/c.b4fe4e07.jpg";